<div (clickOutside)="clickOutside()" class="dropdown">
  <button
    aria-label="Dropdown profile"
    (click)="toggleDropdown()" class="dropdown-button">
    <app-user-avatar
      size="s"
      [firstName]="user().attributes.given_name"
      [lastName]="user().attributes.family_name"/>
    <i class="icon icon-CaretDown"></i>
  </button>
  <div class="dropdown-content" [class.show]="isDropdownOpen">
    <div class="profile flex row">
      @if (profilePhoto && profilePhoto.length) {
        <img [src]="profilePhoto" alt="User profile image" class="profile-img">
      } @else {
        <app-user-avatar
          size="l"
          [firstName]="user().attributes.given_name"
          [lastName]="user().attributes.family_name"/>
      }
      <div class="title">{{ userName }}</div>
    </div>
    <div class="dropdown-item" (click)="navigateToProfile()">
      <i class="icon-User"></i>
      <span>{{ 'My account'|translate }}</span>
    </div>
    <div class="dropdown-item" (click)="navigateToMyTopics()">
      <i class="icon-BookBookmark"></i>
      <span>{{ 'My topics'|translate }}</span>
    </div>
    <div class="dropdown-item" (click)="logout()">
      <i class="icon-SignOut"></i>
      <span>{{ 'Log out'|translate }}</span>
    </div>
  </div>
</div>
